<template>
  <div class="bankList">
    <!-- Header -->
    <Header :title="title" :right-content="rightContent" />
    
    <!-- Custom Toast Notification -->
    <transition name="toast-fade">
      <div v-if="toast.visible" :key="toast.key" class="custom-toast" :class="toast.type">
        <span class="toast-message">{{ toast.message }}</span>
        <button class="toast-close" type="button" aria-label="关闭提示" @click="closeToast">
          <span class="close-x" aria-hidden="true">×</span>
        </button>
        <span class="toast-progress-bar" aria-hidden="true" />
      </div>
    </transition>

    <div id="content">
      <!-- Loading State -->
      <div v-if="isLoadingList" class="noBankList">
        <div class="item1 loading-content">
          <p>您的银行卡加载中</p>
          <div class="mini-spinner"></div>
        </div>
      </div>
      
      <!-- Empty State -->
      <div v-else-if="withdrawList.length==0" class="noBankList">
        <div class="item1"><img src="@/assets/images/bank/bg1.png"><p>您还没有添加银行卡</p></div>
      </div>
      
      <!-- Populated List -->
      <div v-else class="hasBankList">
        <div v-if="tabIndex==0 && bankList && bankList.length<3" class="prompt">
          <img src="@/assets/images/template/a_top_remind.png">
          <span>为了您的账户资金安全，平台仅支持绑定三张取款银行卡。</span>
        </div>
        <div class="itemList">
          <ul>
            <BankListItem
              v-for="(bank, index) in bankList"
              :key="bank.bankAccountNumber"
              :bank="bank"
              :logo="logoList[index]"
              :tab-index="tabIndex"
              @check-status="checkStatus"
              @edit-branch="goEditBankBranch"
              @unbind="handleUnbind"
            />
          </ul>
        </div>
      </div>
      
      <p class="hint">商业、农商、农村商业等银行新增支行名称， 将方便资金快速到账，敬请添加。 请您在添加后耐心等待审批。如需加急处理，请随时联系客户服务。</p>
      <div class="item2" @click="goProblem">
        <div class="itemCon"><img src="@/assets/images/bank/user_kf.png"><span>绑定银行卡常见问题解答</span></div>
        <div class="itemCon"><img class="size" src="@/assets/images/template/user_arrow.png"></div>
      </div>
      <div v-if="isShow" class="item3">
        <span @click="goAddBankCard"><img src="@/assets/images/bank/user_add to.png">添加新银行卡</span>
        <p>支持储蓄卡/借计卡</p>
      </div>
      <Chat />
    </div>
  </div>
</template>

<script>
require('@/assets/css/bankList.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
import BankListItem from './BankListItem.vue' 
import api from '@/plugins/api'
import { mapState } from 'vuex'

export default {
  name: 'BankList',
  components: { Header, Chat, BankListItem },
  data() {
    return {
      title: '银行卡管理',
      withdrawList: '',
      depositList: '',
      bankNav: [{ name: '取款银行卡', id: '0' }, { name: '存款银行卡', id: '1' }],
      bankList: '',
      bankLogoList: process.env.VUE_APP_BANKLOGO,
      logoList: [],
      withdrawLogoList: [],
      depositLogoList: [],
      bankNum: '',
      isShow: true,
      bankType: this.$route.query.bankType,
      rightContent: 'isNo',
      
      isLoadingList: true,

      toast: {
        visible: false,
        message: '',
        type: 'neutral', 
        timer: null,
        key: 0
      }
    }
  },
  computed: {
    ...mapState(['pageType', 'token', 'tabIndex'])
  },
  beforeCreate() {
    if (!this.tabIndex) this.$store.dispatch('setTabIndex', 0)
  },
  mounted() {
    this.removeFixed()
    this.initData()
  },
  activated() {
    this.removeFixed()
    this.initData()
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      if (mainH) mainH.classList.remove('mainFixed')
    },
    
    async initData() {
      this.isLoadingList = true 
      this.$bus.$emit('loading', false) 
      window.scrollTo(0, 0)
      
      try {
        await Promise.all([this.withdrawBankList(), this.depositBankList()])
      } catch (error) {
        console.error('Error loading bank lists:', error)
      } finally {
        this.isLoadingList = false 
        this.$bus.$emit('loading', true) 
      }
    },

    tabclick(index) {
      this.$store.dispatch('setTabIndex', index)
      if (this.tabIndex == 0) {
        this.bankList = this.withdrawList
        this.logoList = this.withdrawLogoList
        this.bankNum = this.bankList.length
        if (this.bankNum < 3) this.isShow = true
        else this.isShow = false
      } else {
        this.bankList = this.depositList
        this.logoList = this.depositLogoList
        this.bankNum = this.bankList.length
        if (this.bankNum < 5) this.isShow = true
        else this.isShow = false
      }
    },
    goAddBankCard() {
      this.$bus.$emit('loading', false)
      if (this.tabIndex == 0) this.$router.push({ path: '/home/addBankCard', query: { bankType: 0 }})
      else this.$router.push({ path: '/home/addBankCard', query: { bankType: 1 }})
    },
    goEditBankBranch(bankOrder) {
      this.$router.push({ path: '/home/AddBankBranch', query: { bankOrder: bankOrder }})
    },
    checkStatus: function(status, bankOrder) {
      switch (status) {
        case 'EMPTY':
          this.goUploadProof(bankOrder)
          break
        case 'PRE_APPROVAL':
          break
        case 'APPROVAL':
          break
        case 'CANCEL':
          this.goUploadProof(bankOrder)
          break
      }
    },

    withdrawBankList() {
      return api.getWithdrawBankList().then(res => {
        if (res.status && res.data.code == 200 && res.data.data.withdrawBankList) {
          this.withdrawList = res.data.data.withdrawBankList
          if (this.tabIndex == 0) {
            this.bankList = this.withdrawList
            this.bankNum = this.bankList.length
            this.isShow = this.bankNum < 3
          }
          this.withdrawLogoList = [];
          for (const i in this.withdrawList) {
            if (this.bankLogoList.indexOf(this.withdrawList[i].bank) >= 0) {
              this.withdrawLogoList.push(this.withdrawList[i].bank)
            } else {
              this.withdrawLogoList.push('bank')
            }
          }
          if (this.tabIndex == 0) this.logoList = this.withdrawLogoList
        } else {
          this.withdrawList = []
        }
      })
    },

    depositBankList() {
      return api.getDepositBankList().then(res => {
        if (res.status && res.data.code == 200 && res.data.data.depoistBankList) {
          this.depositList = res.data.data.depoistBankList
          if (this.tabIndex == 1) {
            this.bankList = this.depositList
            this.bankNum = this.bankList.length
            this.isShow = this.bankNum < 5
          }
          this.depositLogoList = [];
          for (const i in this.depositList) {
            if (this.bankLogoList.indexOf(this.depositList[i].bank) >= 0) {
              this.depositLogoList.push(this.depositList[i].bank)
            } else {
              this.depositLogoList.push('bank')
            }
          }
          if (this.tabIndex == 1) this.logoList = this.depositLogoList
        } else {
          this.depositList = []
        }
      })
    },

    goProblem() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/problem' })
    },
    goUploadProof(bankOrder) {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/uploadProof', query: { bankOrder: bankOrder }})
    },

    showToast(message, type = 'neutral') {
      this.toast.message = message;
      this.toast.type = type;
      this.toast.key += 1;
      this.toast.visible = true;

      if (this.toast.timer) clearTimeout(this.toast.timer);
      
      this.toast.timer = setTimeout(() => {
        this.closeToast();
      }, 5000); 
    },

    closeToast() {
      this.toast.visible = false;
      if (this.toast.timer) clearTimeout(this.toast.timer);
    },

    async handleUnbind(emittedValue) {
      this.$bus.$emit('loading', false); 

      const targetBankIndex = this.bankList.findIndex(b => b.bankOrder === emittedValue);
      const targetBank = this.bankList[targetBankIndex];
      const bankAccountNumber = targetBank ? targetBank.bankAccountNumber : emittedValue;

      const data = new FormData();
      data.append('bankAccountNumber', bankAccountNumber); 

      let toastMsg = '';
      let toastType = 'neutral';
      let isSuccess = false;

      try {
        const res = await api.deleteWithdrawBank(data);
        
        if (res && res.data && res.data.code === 200) {
          toastMsg = (res.data.data && res.data.data.trim() !== '') ? res.data.data : '操作成功';
          toastType = 'neutral';
          isSuccess = true;
        } else {
          toastMsg = (res && res.data && (res.data.msg || res.data.message)) || '解绑失败，请稍后重试';
          toastType = 'error';
        }
      } catch (error) {
        toastMsg = '网络或服务器异常，请稍后重试';
        toastType = 'error';
      } finally {
        if (isSuccess && targetBankIndex > -1) {
          this.bankList.splice(targetBankIndex, 1);
          this.logoList.splice(targetBankIndex, 1);
          
          if (this.tabIndex === 0) {
             this.withdrawList = this.bankList;
          } else {
             this.depositList = this.bankList;
          }
        }
        
        try {
          if (this.tabIndex === 0) {
              await this.withdrawBankList(); 
          } else {
              await this.depositBankList();
          }
        } catch (e) {
          console.error('Error refreshing bank list', e)
        }
        
        this.$bus.$emit('loading', true); 
        
        this.$nextTick(() => {
          this.showToast(toastMsg, toastType);
        });
      }
    }
  }
}
</script>

<style scoped>
/* =========================================================
   Inline Component Loading State Styles 
========================================================= */
.loading-content {
  display: flex;
  flex-direction: row !important;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
}

.loading-content p {
  font-size: 0.3rem;
  color: #666;
  margin: 0;
  margin-right: 0.2rem; 
}

.mini-spinner {
  width: 0.35rem;
  height: 0.35rem;
  border: 2px solid #ddd;
  border-top-color: #00a6ff; 
  border-radius: 50%;
  animation: mini-spin 1s linear infinite;
}

@keyframes mini-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* =========================================================
   Toast Overlay Styling
========================================================= */
.custom-toast {
  position: fixed;
  bottom: 0.4rem; 
  left: 50%;
  transform: translateX(-50%);
  padding: 0.3rem 0.4rem;
  border-radius: 0.15rem;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  min-width: 4rem;
  overflow: hidden;
  box-shadow: 0 0.1rem 0.3rem rgba(0,0,0,0.2);
  color: #fff;
}

.custom-toast.neutral {
  background-color: rgba(51, 51, 51, 0.95); 
}

.custom-toast.error {
  background-color: rgba(220, 53, 69, 0.95);
}

.custom-toast.error .toast-message {
  white-space: nowrap;
}

.toast-message {
  font-size: 0.3rem;
  font-weight: 500;
  line-height: 1.4;
}

/* Toast Countdown Bar & Close Button */
.toast-close {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
}

.toast-close .close-x {
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
}

.toast-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.8);
  transform: scaleX(1);
  transform-origin: left center;
  animation: countdown-anim 5s linear forwards;
}

@keyframes countdown-anim {
  from { transform: scaleX(1); }
  to { transform: scaleX(0); }
}

.toast-fade-enter-active, .toast-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.toast-fade-enter, .toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, 2rem); 
}
</style>
